module.exports = __webpack_public_path__ + "media/images/undraw/matching/emails-efa2e23c68540013d34f46b89baf2d56.png";